import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import styles from "./TeaserViewer.module.css";

const TeaserViewer = () => {
  const { id } = useParams();
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) {
      setError("회사 ID가 없습니다.");
      setLoading(false);
      return;
    }

    const fetchPdfs = async () => {
      try {
        console.log("🔥 Firestore에서 PDF 목록 불러오기...");
        const companyRef = doc(db, "companies", id);
        const companySnap = await getDoc(companyRef);

        if (!companySnap.exists()) {
          setError("등록된 PDF가 없습니다.");
          setLoading(false);
          return;
        }

        const companyData = companySnap.data() || {};
        console.log("📌 Firestore 데이터:", companyData);

        if (!companyData.pdfs || companyData.pdfs.length === 0) {
          setError("등록된 PDF가 없습니다.");
          setLoading(false);
          return;
        }

        const pdfFiles = companyData.pdfs.filter(
          (item) => item.url && item.url.includes(".pdf")
        );

        console.log("✅ 필터링된 PDF 목록:", pdfFiles);

        if (pdfFiles.length === 0) {
          setError("등록된 PDF가 없습니다.");
        } else {
          setPdfs(pdfFiles);
        }

        setLoading(false);
      } catch (err) {
        console.error("🔥 Firestore에서 PDF 목록 불러오기 실패:", err);
        setError("데이터를 불러오는 중 오류 발생");
        setLoading(false);
      }
    };

    fetchPdfs();
  }, [id]);

  if (loading) return <h2 className={styles.loading}>⏳ 로딩 중...</h2>;
  if (error) return <h2 className={styles.error}>❌ {error}</h2>;

  return (
    <div className={styles.viewerContainer}>
      {pdfs.length > 0 ? (
        <div className={styles.pdfList}>
          {pdfs.map((pdf, index) => (
            <div key={index} className={styles.pdfItem}>
              <iframe
                src={pdf.url + "#toolbar=0"} // Google Docs Viewer 대신 직접 PDF 로드
                title={pdf.name}
                className={styles.pdfFrame}
              />
            </div>
          ))}
        </div>
      ) : (
        <p>📭 등록된 PDF가 없습니다.</p>
      )}
    </div>
  );
};

export default TeaserViewer;
